// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var StringUtils = require("../../../shared/src/StringUtils.bs.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var CommonTypes_User_Name = require("../../../shared/src/types/CommonTypes_User_Name.bs.js");

function getDefaultFirstName(param) {
  return Relude_Option.fold("Unknown", CommonTypes_User_Name.FirstName.toString, param);
}

function getDefaultLastName(param) {
  return Relude_Option.fold("User", CommonTypes_User_Name.LastName.toString, param);
}

function initialIconFromString(str) {
  var arg = function (param) {
    return BrowserStyle.withFont(param, /* OpenSans */1, /* Medium */3, /* Bold */2);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
                  hd: BrowserStyle.alignItems(BrowserStyle.center),
                  tl: {
                    hd: Css.backgroundColor(Curry._1(BrowserStyle.Utils.getColorForString, str)),
                    tl: {
                      hd: BrowserStyle.borderRadius({
                            NAME: "percent",
                            VAL: 50.0
                          }),
                      tl: {
                        hd: BrowserStyle.display(BrowserStyle.flexBox),
                        tl: {
                          hd: BrowserStyle.height(BrowserStyle.rem(2.0)),
                          tl: {
                            hd: BrowserStyle.justifyContent(BrowserStyle.center),
                            tl: {
                              hd: BrowserStyle.width(BrowserStyle.rem(2.0)),
                              tl: {
                                hd: BrowserStyle.color({
                                      TAG: /* White */7,
                                      _0: /* Light */2
                                    }),
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }));
}

function initialIcon(firstName, lastName) {
  return initialIconFromString(getDefaultFirstName(firstName) + getDefaultLastName(lastName));
}

var initials = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.margin("auto"),
      tl: /* [] */0
    });

var Styles = {
  initialIconFromString: initialIconFromString,
  initialIcon: initialIcon,
  initials: initials
};

function BrowserComponents_UserInitials$FromText(Props) {
  var className = Props.className;
  var text = Props.text;
  return React.createElement("div", {
              className: BrowserStyle.Utils.extendBaseStyle(initialIconFromString(text), className)
            }, React.createElement("div", {
                  className: initials
                }, React.createElement(ReactUtils.S.make, {
                      children: text
                    })));
}

var FromText = {
  make: BrowserComponents_UserInitials$FromText
};

function BrowserComponents_UserInitials$FromNames(Props) {
  var className = Props.className;
  var firstName = Props.firstName;
  var lastName = Props.lastName;
  return React.createElement("div", {
              className: BrowserStyle.Utils.extendBaseStyle(initialIcon(firstName, lastName), className)
            }, React.createElement("div", {
                  className: initials
                }, React.createElement(ReactUtils.S.make, {
                      children: StringUtils.getFirstLetter(getDefaultFirstName(firstName)) + StringUtils.getFirstLetter(getDefaultLastName(lastName))
                    })));
}

var FromNames = {
  make: BrowserComponents_UserInitials$FromNames
};

function BrowserComponents_UserInitials$FromUser(Props) {
  var user = Props.user;
  var className = Props.className;
  var tmp = {};
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  var tmp$1 = Relude_Option.map((function (param) {
          return param.name.firstName;
        }), user);
  if (tmp$1 !== undefined) {
    tmp.firstName = Caml_option.valFromOption(tmp$1);
  }
  var tmp$2 = Relude_Option.map((function (param) {
          return param.name.lastName;
        }), user);
  if (tmp$2 !== undefined) {
    tmp.lastName = Caml_option.valFromOption(tmp$2);
  }
  return React.createElement(BrowserComponents_UserInitials$FromNames, tmp);
}

var FromUser = {
  make: BrowserComponents_UserInitials$FromUser
};

var make = BrowserComponents_UserInitials$FromNames;

exports.getDefaultFirstName = getDefaultFirstName;
exports.getDefaultLastName = getDefaultLastName;
exports.Styles = Styles;
exports.FromText = FromText;
exports.FromNames = FromNames;
exports.FromUser = FromUser;
exports.make = make;
/* initials Not a pure module */
